<form [formGroup]="database" (ngSubmit)="onSubmit()">
    <span class="d-flex justify-content-between align-items-center">
        <span class="text-list ms-1 oxanium-medium">Database name</span>
        <span class="text-list oxanium-medium">Box select</span>
    </span>
    <mat-list class="services-list">
        <section>
            @for (service of data_services; track $index) {
            <mat-list-item class="pe-0">
                <span matListItemIcon class="material-symbols-outlined">database</span>
                <span class="d-flex justify-content-between align-items-center">
                    <span class="text-list oxanium-medium">{{service.data_service_name}}</span>
                    <mat-checkbox [checked]="isChecked(service.data_service_id)"
                        (change)="toggleSelection(service.data_service_id)">
                    </mat-checkbox>
                </span>
            </mat-list-item>
            <mat-divider></mat-divider>
            }
        </section>
    </mat-list>
    <div class="mt-3 d-flex justify-content-between align-items-center">
        @if (onCancel) {
            <button mat-button class="login-cancel__button" type="button" (click)="onCancel()">{{cancelText}}</button>
        }
        <button mat-button space-button type="submit">{{CONNECT}}</button>
    </div>
</form>